import React from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { isFeatureEnabled } from 'ff/common/ffAppUtils';

import { hasDebriefLicense } from 'ff/debrief/utils';
import { RouteContext } from 'ff/debrief/router';
import Kebab from 'ff/debrief/components/menu/Kebab';
import DebriefButton from 'ff/debrief/components/DebriefButton';

interface Props {
    isCompleted?: boolean;
}
const ActionRow: React.FC<Props> = props => {
    const { isCompleted } = props;

    const routeContext = React.useContext(RouteContext);

    const showDebriefButton = () => {
        if (isFeatureEnabled('debrief_features') && hasDebriefLicense()) {
            return isCompleted;
        }
        return false;
    };
    return (
        <Stack direction="row" justifyContent="end" gap={1}>
            {showDebriefButton() ? (
                <DebriefButton linkToDebrief={routeContext.debriefLink} />
            ) : (
                <Button component={routeContext.debriefLink} variant="outlined">
                    Details
                </Button>
            )}
            <Kebab></Kebab>
        </Stack>
    );
};

export default ActionRow;
